import { Button, type ButtonProps } from "react-bootstrap";
import { MdRemoveRedEye } from "react-icons/md";

const ShowButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdRemoveRedEye /> {children}
  </Button>
);

export default ShowButton;
